(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  var _cookiePolicy = Cookies.get("cookiePolicy");

  if ($(".cookie-policy").length > 0 && _cookiePolicy != "true") {
    $('.cookie-policy').addClass('active');
  }

  $('.cookie-policy .cookie-close').click(function (e) {
    e.preventDefault();
    $(this).parents('.cookie-policy').removeClass('active');
    Cookies.set("cookiePolicy", "true", {
      expires: 999
    });
  });
  var year = new Date().getFullYear();
  $('#year').html(year);
}

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  $('.phone_mask').mask('(000) 000-0000');
  $.validator.addMethod("validate_email", function (value, element) {
    if (/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value)) {
      return true;
    } else {
      return false;
    }
  });
  $.validator.addMethod("lettersonly", function (value, element) {
    return this.optional(element) || /^[a-zA-Z ıİşŞÜüğĞÇçöÖ]+$/i.test(value);
  });
  $("#contactForm").validate({
    ignore: [],
    errorClass: "error",
    errorPlacement: function errorPlacement(error, element) {
      var elementName = element[0].className; //console.log(elementName);

      if (elementName == 'parent-error error') {
        $(element).parent(".form-item").addClass('error-validation');
        error.insertAfter($(element)); //error-msg add.
      } else {
        error.insertAfter($(element)); //error-msg add.
      }
    },
    rules: {
      nameSurname: {
        required: true,
        lettersonly: true
      },
      email: {
        required: true,
        validate_email: true
      },
      phone: {
        required: true,
        minlength: 14
      },
      message: {
        required: true
      }
      /*kvkk : {
      	required: true
      }*/

    },

    /*unhighlight: function (element, errorClass, validClass) {
    	if ($(element).is('select')) {
    		//error.insertAfter($(element).next());
    		$(element).parents('.form-item').removeClass('error-validation');
    	}
    },*/
    submitHandler: function submitHandler(form) {
      // do other things for a valid form
      //console.log('form submit');
      console.log('...');
      formSend(form);
    },
    invalidHandler: function invalidHandler(form, validator) {
      /*$('html, body').animate({
          scrollTop: $(validator.errorList[0].element).offset().top-$('header').innerHeight() - 30
      }, 1000);*/
    }
  });
}

function formSend(form) {
  var formWrapper = $('.form-wrapper');
  var action = $(form).attr("action"),
      method = $(form).attr("method"),
      name = $(form).attr('name'),
      veri = $(form).serialize(),
      validate = $(form); //console.log(veri);

  $.ajax({
    type: method,
    url: action,
    data: veri,
    cache: false,
    success: function success(data) {
      //data.success = true;
      setTimeout(function () {
        sessionStorage.clear();
      }, 3000);

      if (data == 1) {
        toastr.success(validate.data('success-message'), validate.data('success-title'));
        setTimeout(function () {
          window.location.reload();
        }, 3000);
      } else {
        console.log('error');
        toastr.error(validate.data('error-message'), validate.data('error-title'));
        setTimeout(function () {
          window.location.reload();
        }, 3000);
      }
    }
  });
}

},{}],3:[function(require,module,exports){
"use strict";

var _form = _interopRequireDefault(require("./app/form"));

var _cookie = _interopRequireDefault(require("./app/cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

$(document).ready(function () {
  (0, _form["default"])();
  (0, _cookie["default"])();
  toastr.options = {
    "closeButton": false,
    "debug": false,
    "newestOnTop": false,
    "progressBar": true,
    "positionClass": "toast-top-right",
    "preventDuplicates": false,
    "showDuration": "300",
    "hideDuration": "3000",
    "timeOut": "3000",
    "extendedTimeOut": "100",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
  };
  /*toastr.options = {
  	"closeButton": true,
  	"debug": false,
  	"newestOnTop": false,
  	"progressBar": false,
  	"positionClass": "toast-top-center",
  	"preventDuplicates": false,
  	"onclick": null,
  	"showDuration": "300",
  	"hideDuration": "1000",
  	"timeOut": "60000",
  	"extendedTimeOut": "60000",
  	"showEasing": "swing",
  	"hideEasing": "linear",
  	"showMethod": "fadeIn",
  	"hideMethod": "fadeOut"
  };*/
  //dropdown bug.

  $(".dropdown").on("click", ".dropdown-toggle", function (e) {
    e.preventDefault();
    $(this).parent().addClass("show");
    $(this).attr("aria-expanded", "true");
    $(this).next().addClass("show");
  });
  $('a[data-fancybox]').fancybox({
    animationEffect: "fade"
  });
  var offer_button = $('.product-detail__top .offer-button');
  var product_name = offer_button.parents('section').find('h4').html();
  offer_button.click(function (e) {
    e.preventDefault(); //console.log(product_name);

    sessionStorage.setItem("offer_product_name", product_name);
    toastr.success($(this).data('success'), $(this).data('success-title'));
    var this_location = $(this).data('url');
    setTimeout(function () {
      window.location.href = "".concat(this_location);
    }, 2500);
  });

  if ($('#contactForm')) {
    $('#contactForm').find('input[name="product_name"]').val(sessionStorage.getItem("offer_product_name"));
  }
  /*let menu = $('.wrapper__left-menu');
  menu.find('.sub-toggle').click(function(e){
  	e.preventDefault();
  	$(this).parents('li').find('.sub-dropdown').slideToggle();
  });*/

});

},{"./app/cookie":1,"./app/form":2}]},{},[3]);
